export function formatNumber(value, decimals) {
    if (decimals === void 0) { decimals = 2; }
    // Convert the number to a string with 2 decimal places as default
    var formatted = value.toFixed(decimals);
    // Remove trailing zeros if they are not needed
    formatted = parseFloat(formatted).toString();
    return formatted;
}
